import { RuntimeVO } from 'library/ts/utilities/RuntimeVO';
export class IFrameRuntimeVO extends RuntimeVO {
    constructor() {
        super('smart-tag-iframe', 'iframe');
    }
    get startupCallback() {
        let domCallback;
        const callbackParamName = 'startupCallback';
        const defaultCallbackMethodName = 'getSmartTagParams';
        const paramsCallbackMethodName = this.utils.URL.getQueryField(callbackParamName, this?.app?.url);
        domCallback = this?.utils?.DOM?.getDeepVal(window, defaultCallbackMethodName);
        if (!this.utils.Type.isFunction(domCallback) && !this.utils.Type.isEmpty(paramsCallbackMethodName) && this.utils.Type.isString(paramsCallbackMethodName)) {
            domCallback = this.utils.DOM.getDeepVal(window, paramsCallbackMethodName);
        }
        return domCallback;
    }
    get uuid() {
        return this.utils.URL.getQueryField('uuid', this?.app?.url);
    }
}
